// extracted by mini-css-extract-plugin
module.exports = {"posts":"Posts_posts__1oVGN","row":"Posts_row__34US_","column":"Posts_column__14xEy","cover":"Posts_cover__MokY5"};